import { CircularProgress, Container, Grid, Typography } from "@mui/material";
import config from "../../utils/config";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function PurchaseInfo(props) {
	const { organizationId, sessionId, type } = useParams();

	const [loading, setLoading] = useState(true);
	const [statusText, setStatusText] = useState("Getting payment information...");
	const [paymentIntent, setPaymentIntent] = useState(null);

	useEffect(() => {
		getPaymentInfo(organizationId, sessionId);
	}, []); //eslint-disable-line

	const getPaymentInfo = (organizationId, sessionId) => {
		setTimeout(() => {
			axios
				.get(`${config.API_ENDPOINT}/checkout/session/${organizationId}/${sessionId}`)
				.then((res) => {
					let session = res.data;

					if (session.paymentStatus === "paid") {
						if (type === "esncard") {
							setStatusText(
								"Thank you for purchasing your ESNcard. Please check your inbox."
							);
							setLoading(false);
							setPaymentIntent(session.paymentIntent);
						} else if (type === "event") {
							setStatusText(
								"Thank you for purchasing this event. Please check your inbox."
							);
							setLoading(false);
							setPaymentIntent(session.paymentIntent);
						}
					} else {
						setStatusText("An error occurred while processing your payment.");
						setLoading(false);
						setPaymentIntent(session.paymentIntent);
					}
				})
				.catch(() => {
					toast.error("An unexpected error has occurred");
				});
		}, 2000);
	};

	return (
		<Container sx={{ p: 5 }}>
			<Grid
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justify="center"
			>
				<Grid item xs={3}>
					{loading ? <CircularProgress /> : null}
				</Grid>
				<Grid item xs={3}>
					<Typography style={{ textAlign: "center" }}>{statusText}</Typography>
				</Grid>
				{paymentIntent == null ? null : (
					<Grid item xs={3}>
						<Typography
							style={{ fontSize: 10, marginTop: 10, textAlign: "center" }}
						>
							If you have any problem during this process, contact your ESN office
							and provide this code:
							<br />
							<i>{paymentIntent}</i>
						</Typography>
					</Grid>
				)}
			</Grid>
		</Container>
	);
}

export default PurchaseInfo;